import React from 'react'
import { Box, Button, Typography, useMediaQuery } from '@material-ui/core'
import { useIntl } from 'gatsby-plugin-intl'
import { useStyles } from './ProductInfo.style'
import { resolveImageUrlForDeviceAndLocale } from '../../utils/resolveImageUrlForDeviceAndLocale'

const ProductInfoVariationSixty = (props) => {
  const styles = useStyles()
  const { locale } = useIntl()
  const { t } = props

  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('sm'))

  let content
  let grey = false
  if (props.subType === 'svg') {
    content = (
      <Box>
        <Box className={styles.iconContainer}>
          <Box
            style={{
              marginTop: props.adjustIconTop
                ? `${props.adjustIconTop}px`
                : '0px',
            }}
            className={styles.icon}
          >
            {props.imageUrl ? (
              <img
                src={resolveImageUrlForDeviceAndLocale(
                  props.imageUrl,
                  locale,
                  isDesktop,
                  props.imageShouldSwitchLocale,
                )}
              />
            ) : (
              props.icon
            )}
          </Box>
        </Box>
        <Box className={styles.titleContainer}>
          <Typography variant="h6" className={styles.title}>
            {t(props.title)}
          </Typography>
        </Box>
      </Box>
    )
  } else if (props.subType === 'cta') {
    grey = true
    content = (
      <Box className={styles.ctaVariantContainer}>
        <Box>
          <Typography variant="h6" className={styles.ctaVariantTitle}>
            {t(props.title)}
          </Typography>
          <Button
            className={styles.button}
            variant="contained"
            color="secondary"
            href={props.ctaHref ? `/${locale}${props.ctaHref}` : '#'}
          >
            {t('Read More')}
          </Button>
        </Box>
        <Box className={styles.imageContainer}>
          <img
            src={resolveImageUrlForDeviceAndLocale(
              props.imageUrl,
              locale,
              isDesktop,
              props.imageShouldSwitchLocale,
            )}
            width="100%"
          />
        </Box>
      </Box>
    )
  }

  return (
    <Box
      className={[
        styles.sixtyVariantRoot,
        grey && styles.sixtyVariantRootGrey,
        props.subType === 'cta' && styles.ctaVariantRoot,
      ].join(' ')}
      style={{
        width: 'calc(60% - 10px)',
      }}
    >
      {content}
    </Box>
  )
}

export default ProductInfoVariationSixty
